import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import CloseIcon from 'web-ui-kit/assets/CloseIcon';
import { backgroundTransparentM, backgroundLightM } from 'web-ui-kit/colors';
import { MQ_FOR_TABLET_PORTRAIT_UP_NO_MIN_HEIGHT } from 'web-ui-kit/media';
import ResponsiveModal from 'web-ui-kit/responsiveModal';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var KEYCODE_ESCAPE = 27;
/**
 * A modal that prompts the user to complete additional tasks.
 *
 * The modal overlay will cover the entire viewport and prevent body scrolling.
 *
 * The modal close event will be dispatched when:
 *  (1) the overlay is clicked
 *  (2) the escape key is pressed
 *  or (3) the xout icon is clicked
 */

function FormModal(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'form' : _ref$id,
      _ref$onOverlayClick = _ref.onOverlayClick,
      onOverlayClick = _ref$onOverlayClick === void 0 ? undefined : _ref$onOverlayClick;

  var handleModalClose = function handleModalClose() {
    dispatch({
      type: "".concat(id, "-modal-close-request")
    });
  }; // Dispatch close modal event on Escape key press.


  useEffect(function () {
    var handleKeyDown = function handleKeyDown(e) {
      return e.keyCode === KEYCODE_ESCAPE && handleModalClose();
    };

    window.addEventListener('keydown', handleKeyDown);
    return function () {
      return window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  var Close = styles.Close,
      Modal = styles.Modal,
      ModalContainer = styles.ModalContainer,
      Overlay = styles.Overlay;
  return (
    /*#__PURE__*/
    React.createElement(Overlay, {
      className: className,
      onOverlayClick: onOverlayClick || handleModalClose
    },
    /*#__PURE__*/
    React.createElement(ModalContainer, {
      className: "".concat(id, "-modal-container")
    },
    /*#__PURE__*/
    React.createElement(Close, {
      className: "".concat(id, "-modal-close"),
      onClick: handleModalClose
    }),
    /*#__PURE__*/
    React.createElement(Modal, {
      "aria-modal": "true",
      className: "".concat(id, "-modal"),
      "data-testid": "".concat(id, "-modal"),
      id: "".concat(id, "-modal"),
      role: "dialog"
    }, children)))
  );
}

FormModal.propTypes = {
  /** The custom form content */
  children: PropTypes.node.isRequired,

  /** Allows extending styles with styled(FormModal) constructor */
  className: PropTypes.string,

  /** For reporting events up to parent */
  dispatch: PropTypes.func,

  /**
   * An optional id string that can be used
   * to help identify the origin of modal events.
   * This string is not user visible.
   */
  id: PropTypes.string,

  /** An optional callback for overlay clicks.
   *  If not provided the default is to dispatch a modal-close-request event.
   */
  onOverlayClick: PropTypes.func
};
var styles = {
  Overlay: styled(ResponsiveModal)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    background-color: ", ";\n\n    /** These modals go on top of everything */\n    z-index: 9999;\n  "])), backgroundTransparentM),
  ModalContainer: styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: relative;\n\n    /** Let the modal width expand to fit content up to the max-width minus some margin */\n    width: 100%;\n    max-width: 28.625rem;\n    margin: 0 1rem;\n\n     /** Limits the max modal height to screen size minus some margin */\n    max-height: calc(100% - 2rem);\n  "]))),
  Modal: styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    /** Make the modal content the same size as the modal container */\n    width: 100%;\n    height: 100%;\n\n    /** Allows the modal content to scroll when its larger than its height. */\n    overflow: auto;\n\n    background-color: ", ";\n    border-radius: 4px;\n    box-sizing: border-box;\n    padding: 2.5rem 1.5rem 1.5rem 1.5rem;\n\n    ", " {\n      padding: 2.5rem 2rem 2rem 2rem;\n    }\n  "])), backgroundLightM, MQ_FOR_TABLET_PORTRAIT_UP_NO_MIN_HEIGHT),
  Close: styled(CloseIcon)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0.75rem;\n    right: 0.75rem;\n    z-index: 1;\n  "])))
};
export default FormModal;